import styled, { css } from 'styled-components';

// Import styles
import { flex, transitionMain } from 'components/styles';

export const Label = styled.label<{ disabled?: boolean }>`
	display: grid;
	grid-template-columns: 1.8rem auto;
	column-gap: 1.2rem;

	${({ disabled }) =>
		disabled &&
		css`
			* {
				opacity: 0.5;
				cursor: not-allowed !important;
			}
		`}
`;

export const InputHidden = styled.input`
	display: none;
`;

export const CheckboxStyled = styled.div<{ isError?: boolean; checked?: boolean }>`
	${flex()};
	width: 1.8rem;
	height: 1.8rem;
	border: 1px solid ${({ theme }) => theme.configurator.color.highlight};
	border-radius: 2px;
	cursor: pointer;
	${transitionMain}

	${({ theme, isError }) =>
		isError &&
		css`
			border-color: ${theme.configurator.color.error};
		`}

	${({ theme, checked }) =>
		checked &&
		css`
			background-color: ${theme.user.agreements.checkboxBorderColor};
		`}

	svg {
		width: 1.4rem;
		height: 1.4rem;
	}
`;

export const Content = styled.div<{ required?: boolean }>`
	color: ${({ theme }) => theme.configurator.color.primary};
	font-size: 1.6rem;
	cursor: pointer;
	line-height: 1.4em;
	font-weight: ${({ theme }) => theme.font.light};

	a {
		color: ${({ theme }) => theme.configurator.color.highlight};

		&:hover {
			color: ${({ theme }) => theme.configurator.color.secondary};
		}
	}

	${({ required }) =>
		required &&
		css`
			&:before {
				content: '*';
				margin-right: 0.6rem;
			}
		`}
`;
